exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.padding-L[data-v-0eb9e090] {\n  padding-left: 7px;\n}\n.padding-R[data-v-0eb9e090] {\n  padding-right: 7px;\n}\n.button.cta[data-v-0eb9e090] {\n  font-size: 11px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/TncReservationsControl.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,gBAAgB;CACjB","file":"TncReservationsControl.vue","sourcesContent":["\n.padding-L[data-v-0eb9e090] {\n  padding-left: 7px;\n}\n.padding-R[data-v-0eb9e090] {\n  padding-right: 7px;\n}\n.button.cta[data-v-0eb9e090] {\n  font-size: 11px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0eb9e090","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Laxit/TncReservationsControl.vue
// module id = 2039
// module chunks = 0